define('plugin/social-gallery/model/SocialGalleryModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Gallery data model
     *
     * @class SocialGalleryModel
     */
    return BaseModel.extend({

        urlRoot: '/ext/social-gallery/by/id/',

        defaults: {
            id: '',
            file_id: '',
            description: '',
            path: '/image_files',
            original: '',
            preview: ''
        }

    });

});
